import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ElectricityData, PowerContractInput } from './types';

const KEY = ['ref-production-electricity'];
const ENDPOINT = '/api/ref-production-electricity';

async function requestData(url: string, init?: RequestInit): Promise<ElectricityData> {
    const response = await fetch(url, init);
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message ?? `Les contrats d'électricité n'ont pas pu être chargés ou modifiés (${response.status}).`);
    }
    return response.json();
}

const json = (method: string, body?: unknown): RequestInit => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
});

export function useElectricity() {
    return useQuery({ queryKey: KEY, queryFn: () => requestData(ENDPOINT) });
}

type Mutation =
    | { kind: 'create'; input: PowerContractInput }
    | { kind: 'update'; id: string; patch: Partial<PowerContractInput> }
    | { kind: 'delete'; id: string };

export function useElectricityMutation() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: (mutation: Mutation) => {
            if (mutation.kind === 'create') return requestData(`${ENDPOINT}/contracts`, json('POST', mutation.input));
            if (mutation.kind === 'update') return requestData(`${ENDPOINT}/contracts/${mutation.id}`, json('PATCH', mutation.patch));
            return requestData(`${ENDPOINT}/contracts/${mutation.id}`, json('DELETE'));
        },
        onSuccess: (data) => client.setQueryData(KEY, data),
        onSettled: () => client.invalidateQueries({ queryKey: KEY }),
    });
}
